import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class BrandMetaService extends BaseService {
    static url = "metas";
    static apis = {
        that: this,
        getFilteredBrandMetas: function() {
            return this.that.url + "/brand-metas";
        },

        getFilteredBrandMetaTrans: function() {
            return this.that.url + "/brand-meta-trans";
        },
        getFilteredBrandMetasbyName: function() {
            return this.that.url + "/brand-metas-name";
        },

        getFilteredBrandMetaTransByName: function() {
            return this.that.url + "/brand-meta-trans-name";
        },
    };

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("metas");
    }

    filteredBrandMetas(ids) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: BrandMetaService.apis.getFilteredBrandMetas(),
                    params: { Ids: ids },
                    method: "GET",
                    authorization: false,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    filteredBrandMetaTrans(ids) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: BrandMetaService.apis.getFilteredBrandMetaTrans(),
                    params: { Ids: ids },
                    method: "GET",
                    authorization: false,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    filteredBrandMetasByName(name) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: BrandMetaService.apis.getFilteredBrandMetasbyName(),
                    params: { brandName: name },
                    method: "GET",
                    authorization: false,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    filteredBrandMetaTransByName(name) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: BrandMetaService.apis.getFilteredBrandMetaTransByName(),
                    params: { brandName: name },
                    method: "GET",
                    authorization: false,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }



}

export default BrandMetaService;